import { Middleware } from "@reduxjs/toolkit";

import { saveToStorage } from "../../common/utils/functions/localStorage";

export const cartCacheMiddleware: Middleware =
  (store) => (next) => (action: any) => {
    const result = next(action);

    if (action.type?.startsWith?.("cart/")) {
      const cartItems = store.getState().cart.items;
      try {
        saveToStorage("cart", cartItems);
      } catch {
        // ignore
      }
    }

    return result;
  };